import React from "react";

function Stats({ data }) {
  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="flex divide-x justify-between p-5 rounded-[4px]"
    >
      <div className="w-1/3 text-center">
        <div className="mx-auto font-bold text-[1.7rem]">{data?.total}</div>
        <div className="text-[#808080]">총 재고</div>
      </div>
      <div className="w-1/3 text-center">
        <div className="mx-auto font-bold text-[1.7rem]">
          {data?.totalInToday}
        </div>
        <div className="text-[#808080]">당일 입고</div>
      </div>
      <div className="w-1/3 text-center">
        <div className="mx-auto font-bold text-[1.7rem]">
          {data?.totalOutToday}
        </div>
        <div className="text-[#808080]">당일 출고</div>
      </div>
    </div>
  );
}

export default Stats;
